import axios from 'axios';
import UserSecurity from './user-security.entity';

export default class AuthenticationService {
  static msal: Msal;

  static login(): void {
    if (this.nonAuthenticated()) {
      this.msal.signIn();
    }
  }

  static logout(): void {
    if (this.isAuthenticated()) {
      this.msal.signOut();
    }
  }

  static isAuthenticated(): boolean {
    return this.msal.isAuthenticated();
  }

  static nonAuthenticated(): boolean {
    return !this.isAuthenticated();
  }

  static userLoggedIn(): UserSecurity {
    if (this.isAuthenticated()) {
      return new UserSecurity(this.msal.data.user);
    }
    return new UserSecurity({});
  }

  static token(): Promise<string> {
    return this.msal.acquireToken();
  }

  static photo(): Promise<any> {
    return this.msal
      .msGraph([{ url: '/me' }, { url: '/me/photo/$value', responseType: 'blob' }]);
  }

  static async exchangeCodeForToken(code: string) {
    const response = await axios.post('/users/public/login', null, {
      params: {
        code,
        redirect_uri: process.env.VUE_APP_HOST_URL_BASE,
      },
    });
    return response;
  }

  static refreshTokenRequest(token: string) {
    return axios.post('/users/public/refresh-token', token);
  }
}

interface Msal {
  data: any;
  isAuthenticated(): boolean;
  signIn(): any;
  signOut(): any;
  acquireToken(): Promise<string>;
  msGraph(endpoins: any[]): Promise<any>;
}
